import type { TenantSettings } from "@/types/tenant";

export const SITE_TEMPLATES = [
  {
    key: "classic",
    label: "Classic",
    description: "Centered logo, boxed sections, balanced rhythm",
  },
  {
    key: "editorial",
    label: "Editorial",
    description: "Left-aligned masthead, serif emphasis, generous whitespace",
  },
  {
    key: "bold",
    label: "Bold",
    description: "Full-bleed color-block sections, oversized type, split hero",
  },
  {
    key: "minimal",
    label: "Minimal",
    description: "Thin header, monochrome + one accent, hairline dividers",
  },
  {
    key: "tranquil",
    label: "Tranquil",
    description: "Soft, leafy wellness look with airy cards and calm type",
  },
] as const;

export type SiteTemplateKey = (typeof SITE_TEMPLATES)[number]["key"];

const DEFAULT_SITE_TEMPLATE: SiteTemplateKey = "classic";

const templatesByKey = new Map<string, (typeof SITE_TEMPLATES)[number]>(
  SITE_TEMPLATES.map((template) => [template.key, template]),
);

export function getSiteTemplateKey(settings: TenantSettings = {}): SiteTemplateKey {
  return templatesByKey.has(String(settings.template))
    ? (settings.template as SiteTemplateKey)
    : DEFAULT_SITE_TEMPLATE;
}

export function getSiteTemplate(settings: TenantSettings = {}) {
  return templatesByKey.get(getSiteTemplateKey(settings))!;
}

export function isEditorialTemplate(template: SiteTemplateKey): boolean {
  return template === "editorial";
}
